import axiosInstanceReport from "./authentication/axiosInstanceReport";

export const reportServices = {

  getJobReport: async (jobId) => {
    const response = await axiosInstanceReport.post(`/reports/job/${jobId}`);
    return response;
  },

  downloadJobStatusReport: async (formData) => {
    const response = await axiosInstanceReport.post("/reports/jobStatus", formData);
    return response;
  },

  downloadClientWiseJobReport: async (formData) => {
    const response = await axiosInstanceReport.post("/reports/cilentWiseJob", formData);
    return response;
  },

  downloadMissedExpectedDateReport: async (formData) => {
    const response = await axiosInstanceReport.post("/reports/missedExpectedDateReport", formData);
    return response;
  },

  downloadEmployeeEfficiencyReport: async (formData) => {
    const response = await axiosInstanceReport.post("/reports/empEfficiencyReport", formData);
    return response;
  },

  downloadEmployeeExtraTaskReport: async (formData) => {
    const response = await axiosInstanceReport.post("/reports/extraTaskReport", formData);
    return response;
  },

  downloadEmployeeJobTaskReport: async (formData) => {
    const response = await axiosInstanceReport.post("/reports/empJobTaskReport", formData);
    return response;
  },

  downloadEmployeeWiseJobReport: async (formData) => {
    const response = await axiosInstanceReport.post("/reports/empWiseJobReport", formData);
    return response;
  },

  downloadJobPlanReport: async (jobId) => {
    const response = await axiosInstanceReport.post(`/reports/jobPlanReport/${jobId}`);
    return response;
  },

  downloadJobPlanReportPdf: async (jobId) => {
    const response = await axiosInstanceReport.post(`/reports/downloadJobPlanReportPdf/${jobId}`);
    return response;
  },

  downloadJobWiseReport: async (jobId) => {
    const response = await axiosInstanceReport.post(`/reports/jobWiseReport/${jobId}`);
    return response;
  },

  downloadJobChecklistReport: async (jobId) => {
    const response = await axiosInstanceReport.post(`/reports/jobChecklistReport/${jobId}`);
    return response;
  },

  downloadCompletedJobsReport: async (formData) => {
    const response = await axiosInstanceReport.post("/reports/completedJobsReport", formData);
    return response;
  },

  // ── Leave Report ────────────────────────────────────────────────────────
  downloadLeaveReport: async (formData) => {
    const response = await axiosInstanceReport.post("/leave/leaveReport", formData);
    return response;
  }

};
